import React from "react";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";
import styles from "./impact_count.module.scss";

const VFairImpactCount = () => {
  const [focus, setFocus] = React.useState(false);
  return (
    <section className={styles.counter_section}>
      <div className="container">
        <div className={styles.impact_wrapper}>
          <h2>
            <span className="color-orange">Impact</span> that counts
          </h2>
        </div>
        <div className={styles.impact_count}>
          <div className={styles.counter_wrapper}>
            <div className={styles.counter}>
              <CountUp
                start={focus ? 0 : undefined}
                end={200000}
                duration={1}
                redraw={true}
                separator=","
              >
                {({ countUpRef }) => (
                  <div>
                    <span ref={countUpRef} />
                    <VisibilitySensor
                      onChange={(isVisible) => {
                        if (isVisible) {
                          setFocus(true);
                        }
                      }}
                    >
                      <span>+</span>
                    </VisibilitySensor>
                  </div>
                )}
              </CountUp>
            </div>
            <p className="dark:text-white  text-[#113759] text-[20px] font-medium lending-[28px] mb-6">
              Student Registrations
            </p>
          </div>
          <div className={styles.counter_wrapper}>
            <div className={styles.counter}>
              <CountUp
                start={focus ? 0 : undefined}
                end={100}
                duration={1}
                redraw={true}
              >
                {({ countUpRef }) => (
                  <div>
                    <span ref={countUpRef} />
                    <VisibilitySensor
                      onChange={(isVisible) => {
                        if (isVisible) {
                          setFocus(true);
                        }
                      }}
                    >
                      <span>+</span>
                    </VisibilitySensor>
                  </div>
                )}
              </CountUp>
            </div>
            <p className={styles.counter_text}>Student Registrations</p>
          </div>
          <div className={styles.counter_wrapper}>
            <div className={styles.counter}>
              <CountUp
                start={focus ? 0 : undefined}
                end={4.5}
                duration={1}
                redraw={true}
                // separator="/"
                decimals={1}
              >
                {({ countUpRef }) => (
                  <div>
                    <span ref={countUpRef} />
                    <VisibilitySensor
                      onChange={(isVisible) => {
                        if (isVisible) {
                          setFocus(true);
                        }
                      }}
                    >
                      <span>/5</span>
                    </VisibilitySensor>
                  </div>
                )}
              </CountUp>
            </div>
            <p className="dark:text-white  text-[#113759] text-[20px] font-medium lending-[28px] mb-6">
              Happiness Rating
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VFairImpactCount;
